import React, { useState, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Card,
  CardContent,
  Chip,
  Tabs,
  Tab,
  Alert,
  Paper,
  CircularProgress,
} from '@mui/material';
import ResponsiveDialog from './ResponsiveDialog';
import {
  Search as SearchIcon,
  Clear as ClearIcon,
  Check as CheckIcon,
  CloudUpload as UploadIcon,
} from '@mui/icons-material';
import apiService from '../services/api';
import { getApiOrigin } from '../config/environment';
import {
  // Électronique et technologie
  Smartphone,
  Laptop,
  Computer,
  Tablet,
  Headphones,
  Speaker,
  Camera,
  Watch,
  Tv,
  Router,
  Memory,
  Storage,
  Devices,
  
  // Vêtements et mode
  Checkroom,
  ShoppingBag,
  Diamond,
  Watch as WatchIcon,
  
  // Maison et jardin
  Home,
  Chair,
  Bed,
  Kitchen,
  LocalLaundryService,
  Yard,
  Pool,
  Balcony,
  Garage,
  
  // Transport
  DirectionsCar,
  TwoWheeler,
  PedalBike,
  Train,
  Flight,
  DirectionsBoat,
  LocalGasStation,
  
  // Sports et loisirs
  SportsSoccer,
  SportsBasketball,
  SportsTennis,
  SportsGolf,
  SportsVolleyball,
  SportsHockey,
  SportsBaseball,
  FitnessCenter,
  Hiking,
  Surfing,
  
  // Animaux
  Pets,
  
  // Outils et bricolage
  Build,
  Handyman,
  Construction,
  Plumbing,
  ElectricalServices,
  CleaningServices,
  Security,
  Lock,
  Key,
  
  // Santé et beauté
  LocalHospital,
  Medication,
  HealthAndSafety,
  Spa,
  LocalPharmacy,
  
  // Éducation et travail
  School,
  Work,
  Business,
  MenuBook,
  Science,
  Engineering,
  
  // Nourriture et boisson
  Restaurant,
  LocalPizza,
  LocalCafe,
  WineBar,
  Cake,
  Icecream,
  
  // Argent et finance
  AccountBalanceWallet,
  CreditCard,
  AttachMoney,
  Savings,
  TrendingUp,
  
  // Documents et papiers
  Description,
  Article,
  Folder,
  Archive,
  PictureAsPdf,
  
  // Divers
  Category,
  Help,
  Info,
  Star,
  Favorite,
  Email,
  Phone,
  LocationOn,
  Event,
  Settings,
} from '@mui/icons-material';

// Banque d'icônes organisée par catégories
const iconCategories = {
  'Électronique': [
    { name: 'smartphone', icon: Smartphone, label: 'Smartphone' },
    { name: 'laptop', icon: Laptop, label: 'Ordinateur portable' },
    { name: 'computer', icon: Computer, label: 'Ordinateur' },
    { name: 'tablet', icon: Tablet, label: 'Tablette' },
    { name: 'headphones', icon: Headphones, label: 'Casque' },
    { name: 'speaker', icon: Speaker, label: 'Haut-parleur' },
    { name: 'camera', icon: Camera, label: 'Appareil photo' },
    { name: 'watch', icon: Watch, label: 'Montre' },
    { name: 'tv', icon: Tv, label: 'Télévision' },
    { name: 'router', icon: Router, label: 'Routeur' },
    { name: 'memory', icon: Memory, label: 'Mémoire' },
    { name: 'storage', icon: Storage, label: 'Stockage' },
    { name: 'devices', icon: Devices, label: 'Appareils' },
  ],
  'Vêtements': [
    { name: 'clothes', icon: Checkroom, label: 'Vêtements' },
    { name: 'shopping-bag', icon: ShoppingBag, label: 'Sac' },
    { name: 'diamond', icon: Diamond, label: 'Bijoux' },
    { name: 'watch-clothes', icon: WatchIcon, label: 'Montre' },
  ],
  'Maison': [
    { name: 'home', icon: Home, label: 'Maison' },
    { name: 'chair', icon: Chair, label: 'Chaise' },
    { name: 'bed', icon: Bed, label: 'Lit' },
    { name: 'kitchen', icon: Kitchen, label: 'Cuisine' },
    { name: 'laundry', icon: LocalLaundryService, label: 'Lave-linge' },
    { name: 'yard', icon: Yard, label: 'Jardin' },
    { name: 'pool', icon: Pool, label: 'Piscine' },
    { name: 'balcony', icon: Balcony, label: 'Balcon' },
    { name: 'garage', icon: Garage, label: 'Garage' },
  ],
  'Transport': [
    { name: 'car', icon: DirectionsCar, label: 'Voiture' },
    { name: 'motorcycle', icon: TwoWheeler, label: 'Moto' },
    { name: 'bike', icon: PedalBike, label: 'Vélo' },
    { name: 'train', icon: Train, label: 'Train' },
    { name: 'flight', icon: Flight, label: 'Avion' },
    { name: 'boat', icon: DirectionsBoat, label: 'Bateau' },
    { name: 'gas-station', icon: LocalGasStation, label: 'Station-service' },
  ],
  'Sports': [
    { name: 'soccer', icon: SportsSoccer, label: 'Football' },
    { name: 'basketball', icon: SportsBasketball, label: 'Basketball' },
    { name: 'tennis', icon: SportsTennis, label: 'Tennis' },
    { name: 'golf', icon: SportsGolf, label: 'Golf' },
    { name: 'volleyball', icon: SportsVolleyball, label: 'Volleyball' },
    { name: 'hockey', icon: SportsHockey, label: 'Hockey' },
    { name: 'baseball', icon: SportsBaseball, label: 'Baseball' },
    { name: 'fitness', icon: FitnessCenter, label: 'Fitness' },
    { name: 'hiking', icon: Hiking, label: 'Randonnée' },
    { name: 'surfing', icon: Surfing, label: 'Surf' },
  ],
  'Animaux': [
    { name: 'pets', icon: Pets, label: 'Animaux' },
  ],
  'Outils': [
    { name: 'build', icon: Build, label: 'Outils' },
    { name: 'handyman', icon: Handyman, label: 'Bricolage' },
    { name: 'construction', icon: Construction, label: 'Construction' },
    { name: 'plumbing', icon: Plumbing, label: 'Plomberie' },
    { name: 'electrical', icon: ElectricalServices, label: 'Électricité' },
    { name: 'cleaning', icon: CleaningServices, label: 'Nettoyage' },
    { name: 'security', icon: Security, label: 'Sécurité' },
    { name: 'lock', icon: Lock, label: 'Cadenas' },
    { name: 'key', icon: Key, label: 'Clé' },
  ],
  'Santé': [
    { name: 'hospital', icon: LocalHospital, label: 'Hôpital' },
    { name: 'medication', icon: Medication, label: 'Médicament' },
    { name: 'health', icon: HealthAndSafety, label: 'Santé' },
    { name: 'spa', icon: Spa, label: 'Spa' },
    { name: 'pharmacy', icon: LocalPharmacy, label: 'Pharmacie' },
  ],
  'Éducation': [
    { name: 'school', icon: School, label: 'École' },
    { name: 'work', icon: Work, label: 'Travail' },
    { name: 'business', icon: Business, label: 'Business' },
    { name: 'book', icon: MenuBook, label: 'Livre' },
    { name: 'science', icon: Science, label: 'Science' },
    { name: 'engineering', icon: Engineering, label: 'Ingénierie' },
  ],
  'Nourriture': [
    { name: 'restaurant', icon: Restaurant, label: 'Restaurant' },
    { name: 'pizza', icon: LocalPizza, label: 'Pizza' },
    { name: 'cafe', icon: LocalCafe, label: 'Café' },
    { name: 'wine', icon: WineBar, label: 'Vin' },
    { name: 'cake', icon: Cake, label: 'Gâteau' },
    { name: 'icecream', icon: Icecream, label: 'Glace' },
  ],
  'Argent': [
    { name: 'wallet', icon: AccountBalanceWallet, label: 'Portefeuille' },
    { name: 'credit-card', icon: CreditCard, label: 'Carte de crédit' },
    { name: 'money', icon: AttachMoney, label: 'Argent' },
    { name: 'savings', icon: Savings, label: 'Épargne' },
    { name: 'trending-up', icon: TrendingUp, label: 'Croissance' },
  ],
  'Documents': [
    { name: 'document', icon: Description, label: 'Document' },
    { name: 'article', icon: Article, label: 'Article' },
    { name: 'folder', icon: Folder, label: 'Dossier' },
    { name: 'archive', icon: Archive, label: 'Archive' },
    { name: 'pdf', icon: PictureAsPdf, label: 'PDF' },
  ],
  'Divers': [
    { name: 'category', icon: Category, label: 'Catégorie' },
    { name: 'help', icon: Help, label: 'Aide' },
    { name: 'info', icon: Info, label: 'Information' },
    { name: 'star', icon: Star, label: 'Étoile' },
    { name: 'heart', icon: Favorite, label: 'Cœur' },
    { name: 'location', icon: LocationOn, label: 'Localisation' },
    { name: 'phone', icon: Phone, label: 'Téléphone' },
    { name: 'email', icon: Email, label: 'Email' },
    { name: 'event', icon: Event, label: 'Événement' },
    { name: 'settings', icon: Settings, label: 'Paramètres' },
  ],
};

interface CustomIcon {
  /** Nom de fichier sur le serveur (ex. mon-icone-68abc.svg) */
  id: string;
  name: string;
  /** URL absolue pour <img> */
  url: string;
}

function mapApiIconsToCustomIcons(raw: unknown): CustomIcon[] {
  if (!Array.isArray(raw)) return [];
  const origin = getApiOrigin();
  return raw.map((item: { filename?: string; url?: string; name?: string }) => {
    const filename = String(item.filename || '');
    const rel =
      item.url && String(item.url).startsWith('/') ? String(item.url) : `/uploads/pictos/${filename}`;
    return {
      id: filename,
      name: (item.name && String(item.name)) || filename.replace(/\.svg$/i, ''),
      url: `${origin}${rel}`,
    };
  });
}

interface IconSelectorProps {
  open: boolean;
  onClose: () => void;
  onSelect: (iconName: string) => void;
  currentIcon?: string;
  /** Fichier SVG sélectionné (champ catégorie `custom_icon_filename`) */
  currentCustomFilename?: string | null;
}

const IconSelector: React.FC<IconSelectorProps> = ({
  open,
  onClose,
  onSelect,
  currentIcon,
  currentCustomFilename,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string>('Électronique');
  const [activeTab, setActiveTab] = useState(0);
  const [customIcons, setCustomIcons] = useState<CustomIcon[]>([]);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [uploadSuccess, setUploadSuccess] = useState<string | null>(null);
  const [deleteTarget, setDeleteTarget] = useState<CustomIcon | null>(null);
  const [deleteError, setDeleteError] = useState<string | null>(null);
  const [deleteSubmitting, setDeleteSubmitting] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Charger les icônes personnalisées depuis l'API
  React.useEffect(() => {
    const loadIcons = async () => {
      try {
        const response = await apiService.getIcons();
        if (response.success && Array.isArray(response.icons)) {
          setCustomIcons(mapApiIconsToCustomIcons(response.icons));
        }
      } catch (error) {
        console.error('Erreur lors du chargement des icônes:', error);
      }
    };
    loadIcons();
  }, []);

  // Fonction pour valider un fichier SVG
  const validateSvgFile = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      if (!file.type.includes('svg')) {
        reject(new Error('Le fichier doit être au format SVG'));
        return;
      }

      if (file.size > 100 * 1024) { // 100KB max
        reject(new Error('Le fichier SVG ne doit pas dépasser 100KB'));
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const svgContent = e.target?.result as string;
        if (!svgContent.includes('<svg')) {
          reject(new Error('Le fichier ne semble pas être un SVG valide'));
          return;
        }
        resolve(svgContent);
      };
      reader.onerror = () => reject(new Error('Erreur lors de la lecture du fichier'));
      reader.readAsText(file);
    });
  };

  // Fonction pour uploader une icône SVG
  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setUploadError(null);
    setUploadSuccess(null);

    try {
      await validateSvgFile(file);
      const iconName = file.name.replace('.svg', '');
      
      try {
        const response = await apiService.uploadIcon(file);
        if (response.success) {
          // Recharger la liste des icônes
          const iconsResponse = await apiService.getIcons();
          if (iconsResponse.success && Array.isArray(iconsResponse.icons)) {
            setCustomIcons(mapApiIconsToCustomIcons(iconsResponse.icons));
          }
          setUploadSuccess(`Icône "${iconName}" ajoutée avec succès !`);
        } else {
          setUploadError(response.error || 'Erreur lors de l\'upload');
          return;
        }
      } catch (error) {
        setUploadError(error instanceof Error ? error.message : 'Erreur lors de l\'upload');
        return;
      }
      
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      setUploadError(error instanceof Error ? error.message : 'Erreur lors de l\'upload');
    }
  };

  const confirmDeleteCustomIcon = async () => {
    if (!deleteTarget?.id) return;
    setDeleteError(null);
    setDeleteSubmitting(true);
    try {
      await apiService.deleteIcon(deleteTarget.id);
      const response = await apiService.getIcons();
      if (response.success && Array.isArray(response.icons)) {
        setCustomIcons(mapApiIconsToCustomIcons(response.icons));
      }
      setDeleteTarget(null);
    } catch (error: unknown) {
      const msg =
        error && typeof error === 'object' && 'response' in error
          ? (error as { response?: { data?: { error?: string; message?: string } } }).response?.data?.error ||
            (error as { response?: { data?: { message?: string } } }).response?.data?.message
          : null;
      setDeleteError(msg || (error instanceof Error ? error.message : 'Suppression impossible.'));
    } finally {
      setDeleteSubmitting(false);
    }
  };

  // Filtrer les icônes selon le terme de recherche
  const filteredIcons = React.useMemo(() => {
    if (activeTab === 1) {
      // Onglet icônes personnalisées
      if (!searchTerm) {
        return customIcons;
      }
      return customIcons.filter(icon =>
        icon.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Onglet icônes Material-UI
    if (!searchTerm) {
      return iconCategories[selectedCategory as keyof typeof iconCategories] || [];
    }

    const allIcons = Object.values(iconCategories).flat();
    return allIcons.filter(icon =>
      icon.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      icon.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, selectedCategory, activeTab, customIcons]);

  const handleIconSelect = (iconName: string) => {
    onSelect(iconName);
    onClose();
  };

  const handleCustomIconSelect = (iconId: string) => {
    onSelect(iconId);
    onClose();
  };

  const handleClearSearch = () => {
    setSearchTerm('');
  };

  return (
    <>
    <ResponsiveDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Sélectionner une icône
        {currentIcon && (
          <Chip
            label={`Actuel: ${currentIcon}`}
            size="small"
            sx={{ ml: 2 }}
            color="primary"
            variant="outlined"
          />
        )}
      </DialogTitle>
      
      <DialogContent>
        {/* Onglets */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
            <Tab label="Icônes Material-UI" />
            <Tab label="Mes icônes SVG" />
          </Tabs>
        </Box>

        {/* Section upload pour les icônes personnalisées */}
        {activeTab === 1 && (
          <Paper sx={{ p: 2, mb: 3, bgcolor: 'grey.50' }}>
            <Typography variant="h6" gutterBottom>
              Ajouter une icône SVG personnalisée
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Téléchargez vos propres icônes au format SVG (max 100KB)
            </Typography>
            
            <input
              ref={fileInputRef}
              type="file"
              accept=".svg"
              onChange={handleFileUpload}
              style={{ display: 'none' }}
            />
            
            <Button
              variant="outlined"
              startIcon={<UploadIcon />}
              onClick={() => fileInputRef.current?.click()}
              sx={{ mb: 2 }}
            >
              Choisir un fichier SVG
            </Button>

            {uploadError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {uploadError}
              </Alert>
            )}

            {uploadSuccess && (
              <Alert severity="success" sx={{ mb: 2 }}>
                {uploadSuccess}
              </Alert>
            )}
          </Paper>
        )}

        {/* Barre de recherche */}
        <TextField
          fullWidth
          placeholder={activeTab === 0 ? "Rechercher une icône..." : "Rechercher dans mes icônes..."}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchTerm && (
              <InputAdornment position="end">
                <IconButton onClick={handleClearSearch} size="small">
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ mb: 3 }}
        />

        {/* Sélecteur de catégorie (seulement si pas de recherche) */}
        {!searchTerm && activeTab === 0 && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" gutterBottom>
              Catégorie:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {Object.keys(iconCategories).map((category) => (
                <Chip
                  key={category}
                  label={category}
                  onClick={() => setSelectedCategory(category)}
                  color={selectedCategory === category ? 'primary' : 'default'}
                  variant={selectedCategory === category ? 'filled' : 'outlined'}
                  size="small"
                />
              ))}
            </Box>
          </Box>
        )}

        {/* Grille d'icônes */}
        <Grid container spacing={2}>
          {activeTab === 0 ? (
            // Icônes Material-UI
            (filteredIcons as any[]).map((iconData, index) => {
              const IconComponent = iconData.icon;
              const isSelected = currentIcon === iconData.name;
              
              return (
                <Grid item xs={6} sm={4} md={3} key={iconData.name}>
                  <Card
                    sx={{
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      border: isSelected ? 2 : 1,
                      borderColor: isSelected ? 'primary.main' : 'divider',
                      backgroundColor: isSelected ? 'primary.50' : 'background.paper',
                      '&:hover': {
                        borderColor: 'primary.main',
                        backgroundColor: 'primary.50',
                        transform: 'translateY(-2px)',
                        boxShadow: 2,
                      },
                    }}
                    onClick={() => handleIconSelect(iconData.name)}
                  >
                    <CardContent sx={{ textAlign: 'center', p: 2 }}>
                      <Box sx={{ position: 'relative' }}>
                        <IconComponent
                          sx={{
                            fontSize: 32,
                            color: isSelected ? 'primary.main' : 'text.primary',
                            mb: 1,
                          }}
                        />
                        {isSelected && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: -8,
                              right: -8,
                              backgroundColor: 'primary.main',
                              borderRadius: '50%',
                              width: 20,
                              height: 20,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <CheckIcon sx={{ fontSize: 14, color: 'white' }} />
                          </Box>
                        )}
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          display: 'block',
                          fontWeight: isSelected ? 600 : 400,
                          color: isSelected ? 'primary.main' : 'text.secondary',
                        }}
                      >
                        {iconData.label}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          display: 'block',
                          fontSize: '0.7rem',
                          color: 'text.disabled',
                          mt: 0.5,
                        }}
                      >
                        {iconData.name}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })
          ) : (
            // Icônes personnalisées SVG
            (filteredIcons as CustomIcon[]).map((iconData) => {
              const isSelected =
                (currentCustomFilename && currentCustomFilename === iconData.id) ||
                currentIcon === iconData.id;

              return (
                <Grid item xs={6} sm={4} md={3} key={iconData.id}>
                  <Card
                    sx={{
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      border: isSelected ? 2 : 1,
                      borderColor: isSelected ? 'primary.main' : 'divider',
                      backgroundColor: isSelected ? 'primary.50' : 'background.paper',
                      '&:hover': {
                        borderColor: 'primary.main',
                        backgroundColor: 'primary.50',
                        transform: 'translateY(-2px)',
                        boxShadow: 2,
                      },
                    }}
                    onClick={() => handleCustomIconSelect(iconData.id)}
                  >
                    <CardContent sx={{ textAlign: 'center', p: 2 }}>
                      <Box sx={{ position: 'relative' }}>
                        <Box
                          component="img"
                          src={iconData.url}
                          alt=""
                          sx={{
                            width: 40,
                            height: 40,
                            mb: 1,
                            objectFit: 'contain',
                            display: 'inline-block',
                            filter: isSelected ? undefined : 'opacity(0.92)',
                          }}
                        />
                        {isSelected && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: -8,
                              right: -8,
                              backgroundColor: 'primary.main',
                              borderRadius: '50%',
                              width: 20,
                              height: 20,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <CheckIcon sx={{ fontSize: 14, color: 'white' }} />
                          </Box>
                        )}
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          display: 'block',
                          fontWeight: isSelected ? 600 : 400,
                          color: isSelected ? 'primary.main' : 'text.secondary',
                        }}
                      >
                        {iconData.name}
                      </Typography>
                      <Button
                        size="small"
                        color="error"
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeleteError(null);
                          setDeleteTarget(iconData);
                        }}
                        sx={{ mt: 1, minWidth: 'auto', p: 0.5 }}
                      >
                        Supprimer
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })
          )}
        </Grid>

        {filteredIcons.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Aucune icône trouvée pour "{searchTerm}"
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          Annuler
        </Button>
        <Button
          onClick={() => handleIconSelect('')}
          variant="outlined"
          color="secondary"
        >
          Supprimer l'icône
        </Button>
      </DialogActions>
    </ResponsiveDialog>

    <Dialog
      open={Boolean(deleteTarget)}
      onClose={() => {
        if (!deleteSubmitting) {
          setDeleteTarget(null);
          setDeleteError(null);
        }
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Supprimer l&apos;icône SVG ?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Le fichier sera retiré du serveur. Les catégories qui l&apos;utilisent n&apos;afficheront plus cette icône
          (pensez à les mettre à jour).
        </Typography>
        {deleteTarget && (
          <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
            <Box component="span" sx={{ fontWeight: 600 }}>{deleteTarget.name}</Box>
            {' '}
            <Box component="span" sx={{ display: 'block', fontSize: '0.75rem', color: 'text.secondary', mt: 0.5 }}>
              {deleteTarget.id}
            </Box>
          </Typography>
        )}
        {deleteError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {deleteError}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => !deleteSubmitting && setDeleteTarget(null)} disabled={deleteSubmitting}>
          Annuler
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={deleteSubmitting}
          onClick={() => void confirmDeleteCustomIcon()}
          startIcon={deleteSubmitting ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default IconSelector;
